import type { ComponentProps } from 'react';
import { ResultCard } from '@globalvisioninc/ui/result-card';

export type DifferenceCardThumbnailStatus = 'ready' | 'loading' | 'noComparison' | 'empty' | 'error';

export type DifferenceCardThumbnailProps = {
  status: DifferenceCardThumbnailStatus;
  src?: string;
  alt: string;
  imgId?: string;
  credentialed?: boolean;
};

type ResultCardThumbnailProps = ComponentProps<typeof ResultCard.Thumbnail>;

const DifferenceCardThumbnail = ({ status, src, alt, imgId, credentialed = false }: DifferenceCardThumbnailProps) => {
  if (status === 'noComparison') {
    return <ResultCard.Placeholder mode="nomatch" />;
  }

  if (status === 'error') {
    return <ResultCard.Placeholder mode="error" />;
  }

  const corsProps = credentialed ? { crossOrigin: 'use-credentials' as const } : {};

  if (status === 'ready' && src) {
    return <ResultCard.Thumbnail src={src} alt={alt} id={imgId} {...corsProps} />;
  }

  return (
    <ResultCard.Thumbnail
      {...({
        isLoading: status === 'loading',
        alt,
        id: imgId,
        ...corsProps,
      } as ResultCardThumbnailProps)}
    />
  );
};

export default DifferenceCardThumbnail;
